const fullcontJump = require('../../../../../components/fullcont/fullcont-jump')
const click = require('../../../../../js/click')
const dbRequest = require('../../../../../js-network/db-request')
const receivepaymentDialog = require('./receivepayment-dialog')

let jumpingToBouncedCheck = false

export function jumperToSale(detail) {
  const line = detail.ev?.target?.closest('.line')
  const otherFieldElement = line?.querySelector('.sale_id .otherField')
  const rawOtherField = otherFieldElement?.getAttribute('otherField')

  if (!rawOtherField) {
    return
  }

  let otherField

  try {
    otherField = JSON.parse(rawOtherField)
  } catch (error) {
    return
  }

  const saleCode = String(otherField.sale_code || '').trim()

  if (saleCode === '') {
    return
  }

  fullcontJump.start({
    actJump: 'goToSales',
    dtId: 'sale-dt',
    toSearch: saleCode,
  })
}

export async function jumperToBouncedCheck(detail) {
  if (jumpingToBouncedCheck) return

  const receivepaymentId = String(detail.dbid || '').trim()

  if (receivepaymentId === '') return

  jumpingToBouncedCheck = true

  try {
    const result = await dbRequest.start(
      { inf: { entity: 'receivepayment', id: receivepaymentId } },
      'server/php/sql/selectOne.php',
    )
    const receivepayment = result?.data?.[0]

    if (result?.status !== 'ok' || !receivepayment) return

    if (receivepayment.payment_method !== 'Check') {
      receivepaymentDialog.start({
        act: 'show',
        id: 'bouncedCheckRequiresCheck',
      })
      return
    }

    const customer = extractCustomer(receivepayment)
    const displayText = [
      receivepayment.code || '',
      customer.name,
      receivepayment.amount_dt || '',
      receivepayment.date_td || '',
    ].join(' - ')

    click.start({
      dest: 'transaction',
      elem: 'page',
      id: 'transaction-page',
      act: 'show',
      leftnav: 'leftnav-transaction-page',
    })
    click.start({
      dest: 'transaction',
      elem: 'fullcont',
      id: 'transaction-fullcont',
      act: 'prepareBouncedCheck',
      receivepayment: {
        id: receivepaymentId,
        displayText,
        amount: receivepayment.amount || '',
        date: receivepayment.date || '',
        customer_id: customer.id,
        customer_name: customer.name,
        invoice_reference: receivepayment.sales_code || '',
      },
    })
  } finally {
    jumpingToBouncedCheck = false
  }
}

function extractCustomer(receivepayment) {
  let selectedCustomer = []

  try {
    selectedCustomer = JSON.parse(receivepayment.customer_id || '[]')
  } catch (error) {
    selectedCustomer = []
  }

  const customer = selectedCustomer[0] || {}

  return {
    id: customer.id === null || customer.id === undefined ? '' : String(customer.id),
    name: String(customer.displayText || receivepayment.customer_name || ''),
  }
}
